<template>
    <div class="main bg-white row">
        <div class="left-block">
            <div class="col left-block-container">
            <h2 class="landingPageTitle txt-black fontGrot">Le BTP, un secteur qui recrute et offre des perspectives d’avenir</h2>
            <p class="txt-content txt-black fontGrot">Le BTP est <span style="font-weight: 600">l'un des principaux employeurs en France</span>, avec environ 1,5 million de salariés. Il propose une large variété de métiers, accessibles à tout niveau d’expérience, et surtout de nombreuses opportunités d’évolution.</p>
            <p class="txt-content txt-black fontGrot">Notre secteur est aussi tourné vers l’avenir. Avec la transition écologique, de nombreux emplois “verts” sont créés, en lien avec l’efficacité énergétique et les énergies renouvelables. Travailler dans le BTP aujourd’hui, c’est <span style="font-weight: 600">participer à la construction d’un futur plus respectueux de l’environnement.</span></p>

            <div class="topBlockButtonContainer">
                <button class="txt-black fontGrot" @click="redirectToDemo">Je postule</button>
            </div>
            </div>
        </div>
        <div class="right-block">
        <img class="imgBlock" src="https://oleciocdn.fra1.cdn.digitaloceanspaces.com/prod/cvtheque/Landing-page-img1.png" />
    </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "PageBlock2",
    methods: {
      redirectToDemo() {
        //window.location.href = "https://demo.jobnavigator.fr/web/index.php/candidature/index#apply";
        // window.location.href = "https://jobnavigator.fr/web/index.php/candidature/index#apply";
        const utmSource = "olecio_job";
        window.location.href = `https://jobnavigator.fr/web/index.php/candidature/index#apply?utm_source=${encodeURIComponent(utmSource)}`;

      }
    }
  };
  </script>
  
  <style src="../pages/landing-page.scss" lang="scss"></style>
  <style scoped>
.left-block {
    flex-basis: 60%;
}
.right-block {
  flex-basis: 40%;
}
.left-block {
    padding-left: 1rem;
    padding-top: 3rem;
    padding-right: 0rem;
    padding-bottom: 0rem;
}
.right-block {
    padding-left: 0rem;
    padding-top: 3rem;
    padding-right: 8rem;
    padding-bottom: 3rem;
}
/* .left-block{
    padding-right: 4rem;
} */
/* .left-block-container {
    padding-right: 2.5rem;
} */
.imgBlock {
    height: 500px;
    width: auto;
    padding-top: 5rem;
    padding-bottom: 6rem;
    background-color: white;
}
  .left-block-container {
    padding-left: 3rem;
    padding-right: 4rem;
    align-items: flex-start;
  }
  #olecio-logo{
    padding-left: 0rem;
  }
  .left-block .txt-content {
    max-width: 40rem;
    text-align: start;
    padding-left: 0rem;
    padding-right: 4rem;
    font-size: 1.125rem;
    line-height: 1.75rem;
    margin-bottom: 0rem;
  }

  .topBlockButtonContainer {
    padding-left: 0rem;
  }
  .topBlockButtonContainer button {
    font-size: 1.5rem;
    line-height: 2rem;
  }
  /* #preTitle {
    text-align: start;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    font-weight: 500;
    font-size: 1.875rem;
    line-height: 2.25rem;
} */
.landingPageTitle {
    text-align: start;
    padding-right: 0rem;
    margin-top: 0.5rem;
    margin-bottom: 1.5rem;
    font-size: 2.75rem;
    line-height: 3rem;
}
  #olecio-logo {
    max-width: 8rem;
    margin-bottom: 2rem;
  }
  button {
    margin-top: 2rem;
    padding: 15px 40px;
    background-color: #e54021;
    color: white;
    border: none;
    cursor: pointer;
  }
  @media screen and (max-width: 460px) {
    .left-block{
      flex-basis: 100%;
      padding-left: 0rem;
    }
    .left-block .txt-content{
      text-align: center;
      padding-left: 1rem;
      padding-right: 1rem;
      /* padding-left: 2rem;
      padding-right: 2rem; */
    }
    .landingPageTitle{
      text-align: center;
      font-size: 1.875rem;
      line-height: 2.25rem;
    }
    .left-block-container{
      align-items: center;
      padding-left: 1rem;
      padding-right: 1rem;
      margin-bottom: 2rem;
    }
  }
  </style>